export const slotGamesTextContent = {
  headingText: "More Games",
};
